import 'bootstrap/dist/css/bootstrap.css';
import React__default from 'react';
import { styled } from 'styled-components';

const RadioButton = styled.input `
  box-shadow: none !important;
  outline: none !important;

  &:focus {
    border-color: #8a00e5 !important;
  }

  &:checked {
    background-color: #8a00e5 !important;
    border-color: #8a00e5 !important;
  }
`;
const Radio = ({ id, name, label, value, disabled = false, isChecked = false, ...props }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("label", { className: "form-check-label noselect" },
            React__default.createElement(RadioButton, { className: "form-check-input", type: "radio", name: name, id: id, value: value, disabled: disabled, checked: isChecked, onChange: props.onChange, style: { marginRight: 5 } }),
            React__default.createElement("span", { style: { opacity: disabled ? 0.3 : 1 } }, label))));
};

export { Radio as default };
//# sourceMappingURL=Radio.js.map
